// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"39757da8","732":"5b82ffc6","977":"6e11af1e"}[chunkId] + ".chunk.js";
};